import NftContractContext from "contexts/NftContractContext";
import { useContext } from "react";

const useNftContract = () => useContext(NftContractContext);

export default useNftContract;
